import { render, staticRenderFns } from "./SoundWave.vue?vue&type=template&id=6181e938&scoped=true"
import script from "./SoundWave.vue?vue&type=script&lang=js"
export * from "./SoundWave.vue?vue&type=script&lang=js"
import style0 from "./SoundWave.vue?vue&type=style&index=0&id=6181e938&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6181e938",
  null
  
)

export default component.exports